var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 30.3333H37.7299L26.3433 41.72C25.4333 42.63 25.4333 44.1233 26.3433 45.0333C27.2533 45.9433 28.7233 45.9433 29.6333 45.0333L45.0099 29.6567C45.9199 28.7467 45.9199 27.2767 45.0099 26.3667L29.6566 10.9667C28.7466 10.0567 27.2766 10.0567 26.3666 10.9667C25.4566 11.8767 25.4566 13.3467 26.3666 14.2567L37.7299 25.6667H11.6666C10.3833 25.6667 9.33325 26.7167 9.33325 28C9.33325 29.2833 10.3833 30.3333 11.6666 30.3333Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward);
export default __webpack_public_path__ + "static/media/arrow-forward.399a93db.svg";
export { ForwardRef as ReactComponent };